import { createSlice } from '@reduxjs/toolkit';
import ls from 'localstorage-slim';

const initialState = {
  isFirstLoad: true,
  isWelcomeScreenHidden: false,
  isMenuOpen: false,
  isAreaOpen: false,
  isTransition: false,
  indexMapTransform: { x: 0, y: 0 },
  areaMapTransform: { x: 0, y: 0 }
};

initialState.isWelcomeScreenHidden = ls.get('kamisamap-welcome-hidden');

export const globalSlice = createSlice({
  name: 'global',
  initialState: initialState,
  reducers: {
    setFirstLoad: (state, action) => {
      state.isFirstLoad = false;
    },

    setIndexMapTransform: (state, action) => {
      state.indexMapTransform = action.payload;
    },

    setAreaMapTransform: (state, action) => {
      state.areaMapTransform = action.payload;
    },

    setAreaOpen: (state, action) => {
      state.isAreaOpen = action.payload;
    },

    setTransition: (state, action) => {
      state.isTransition = action.payload;
    },

    setMenuOpen: (state, action) => {
      state.isMenuOpen = action.payload;
    },

    setWelcomeScreenHidden: (state, action) => {
      state.isWelcomeScreenHidden = action.payload;
    }
  }
});

export const {
  setFirstLoad,
  setIndexMapTransform,
  setAreaMapTransform,
  setAreaOpen,
  setTransition,
  setMenuOpen,
  setWelcomeScreenHidden
} = globalSlice.actions;

// Actions
export const updateIndexMapTransform = val => dispatch => {
  dispatch(setIndexMapTransform(val));
}

export const updateAreaMapTransform = val => dispatch => {
  dispatch(setAreaMapTransform(val));
}

export const updateAreaOpen = val => dispatch => {
  dispatch(setAreaOpen(val));
}

export const updateTransition = val => dispatch => {
  dispatch(setTransition(val));
}

export const updateMenuOpen = val => dispatch => {
  document.body.classList.toggle('no-scroll', val);
  dispatch(setMenuOpen(val));
}

export const updateWelcomeScreen = val => dispatch => {
  const ONE_WEEK = 60 * 60 * 24 * 7;
  ls.set('kamisamap-welcome-hidden', val, { ttl: ONE_WEEK });
  dispatch(setWelcomeScreenHidden(val));
}

// export const incrementIfOdd = (amount) => (dispatch, getState) => {
  // const currentValue = selectCount(getState());
  // if (currentValue % 2 === 1) {
  //   dispatch(incrementByAmount(amount));
  // }
// };

export default globalSlice.reducer;
